import React, { createContext, useContext, useState, useMemo, useCallback } from "react";

// Public website translations: BG (default), EN, DE, FR
export const T = {
  bg: {
    nav_home: "Начало", nav_hotel: "Хотел", nav_rooms: "Стаи", nav_restaurant: "Ресторант",
    nav_menu: "Меню", nav_gallery: "Галерия", nav_book: "Резервирай стая", nav_contact: "Контакти",
    hero_title: "Върбица Хотел & Ресторант",
    hero_sub: "Спокойствие сред природата, топло гостоприемство и автентична кухня в сърцето на Върбица.",
    btn_book_room: "Резервирай стая", btn_restaurant: "Ресторант",
    staff_login: "Вход за персонал",
    sec_hotel: "Хотелът", sec_rooms: "Нашите стаи", sec_apartments: "Апартаменти",
    sec_restaurant: "Ресторантът", sec_nature: "Природа / Върбица", sec_gallery: "Галерия",
    sec_booking: "Резервация", sec_contact: "Контакти",
    hotel_desc: "10 уютни настанявания сред зеленината — 8 стандартни стаи и 2 просторни апартамента с голяма тераса.",
    restaurant_desc: "Автентична българска кухня, приготвена с любов и пресни местни продукти.",
    nature_desc: "Върбица е обградена от гори и чиста природа — идеалното място за отдих и спокойствие.",
    view_menu: "Виж менюто", book_now: "Резервирай сега",
    check_availability: "Провери наличност", arrival: "Пристигане", departure: "Заминаване",
    adults: "Възрастни", children: "Деца", babies: "Бебета (0–2)", nights: "нощувки",
    per_night: "на нощ", total_stay: "общо за престоя", capacity: "Капацитет", view_label: "Изглед",
    amenities: "Удобства", no_rooms: "Няма свободни стаи за избрания период.",
    guest_details: "Данни за госта", first_name: "Име", last_name: "Фамилия", phone: "Телефон",
    email: "Имейл (по избор)", country: "Държава", special: "Специална заявка",
    confirm_booking: "Потвърди резервацията", booking_success: "Резервацията е потвърдена!",
    opening_hours: "Работно време", contact_us: "Свържете се с нас", our_menu: "Нашето меню",
    persons: "лица", select_room: "Избери",
    menu_title: "Меню на ресторанта", menu_kicker: "Хотел Ресторант Върбица", menu_updating: "Менюто се обновява.",
  },
  en: {
    nav_home: "Home", nav_hotel: "Hotel", nav_rooms: "Rooms", nav_restaurant: "Restaurant",
    nav_menu: "Menu", nav_gallery: "Gallery", nav_book: "Book a room", nav_contact: "Contact",
    hero_title: "Hotel Restaurant Varbitsa",
    hero_sub: "Serenity in nature, warm hospitality and authentic cuisine in the heart of Varbitsa.",
    btn_book_room: "Book a room", btn_restaurant: "Restaurant",
    staff_login: "Staff login",
    sec_hotel: "The Hotel", sec_rooms: "Our Rooms", sec_apartments: "Apartments",
    sec_restaurant: "The Restaurant", sec_nature: "Nature / Varbitsa", sec_gallery: "Gallery",
    sec_booking: "Booking", sec_contact: "Contact",
    hotel_desc: "10 cosy accommodations surrounded by greenery — 8 standard rooms and 2 spacious apartments with large terraces.",
    restaurant_desc: "Authentic Bulgarian cuisine prepared with love and fresh local produce.",
    nature_desc: "Varbitsa is surrounded by forests and pristine nature — the perfect place to relax.",
    view_menu: "View menu", book_now: "Book now",
    check_availability: "Check availability", arrival: "Arrival", departure: "Departure",
    adults: "Adults", children: "Children", babies: "Babies (0–2)", nights: "nights",
    per_night: "per night", total_stay: "total stay", capacity: "Capacity", view_label: "View",
    amenities: "Amenities", no_rooms: "No rooms available for the selected period.",
    guest_details: "Guest details", first_name: "First name", last_name: "Last name", phone: "Phone",
    email: "Email (optional)", country: "Country", special: "Special request",
    confirm_booking: "Confirm booking", booking_success: "Booking confirmed!",
    opening_hours: "Opening hours", contact_us: "Contact us", our_menu: "Our menu",
    persons: "persons", select_room: "Select",
    menu_title: "Restaurant menu", menu_kicker: "Hotel Restaurant Varbitsa", menu_updating: "The menu is being updated.",
  },
  de: {
    nav_home: "Startseite", nav_hotel: "Hotel", nav_rooms: "Zimmer", nav_restaurant: "Restaurant",
    nav_menu: "Speisekarte", nav_gallery: "Galerie", nav_book: "Zimmer buchen", nav_contact: "Kontakt",
    hero_title: "Hotel Restaurant Varbitsa",
    hero_sub: "Ruhe in der Natur, herzliche Gastfreundschaft und authentische Küche im Herzen von Varbitsa.",
    btn_book_room: "Zimmer buchen", btn_restaurant: "Restaurant",
    staff_login: "Mitarbeiter-Login",
    sec_hotel: "Das Hotel", sec_rooms: "Unsere Zimmer", sec_apartments: "Apartments",
    sec_restaurant: "Das Restaurant", sec_nature: "Natur / Varbitsa", sec_gallery: "Galerie",
    sec_booking: "Buchung", sec_contact: "Kontakt",
    hotel_desc: "10 gemütliche Unterkünfte im Grünen — 8 Standardzimmer und 2 geräumige Apartments mit großer Terrasse.",
    restaurant_desc: "Authentische bulgarische Küche, mit Liebe und frischen regionalen Produkten zubereitet.",
    nature_desc: "Varbitsa ist von Wäldern und unberührter Natur umgeben — der perfekte Ort zum Entspannen.",
    view_menu: "Speisekarte ansehen", book_now: "Jetzt buchen",
    check_availability: "Verfügbarkeit prüfen", arrival: "Anreise", departure: "Abreise",
    adults: "Erwachsene", children: "Kinder", babies: "Babys (0–2)", nights: "Nächte",
    per_night: "pro Nacht", total_stay: "Gesamt", capacity: "Kapazität", view_label: "Aussicht",
    amenities: "Ausstattung", no_rooms: "Keine Zimmer für den gewählten Zeitraum verfügbar.",
    guest_details: "Gästedaten", first_name: "Vorname", last_name: "Nachname", phone: "Telefon",
    email: "E-Mail (optional)", country: "Land", special: "Sonderwunsch",
    confirm_booking: "Buchung bestätigen", booking_success: "Buchung bestätigt!",
    opening_hours: "Öffnungszeiten", contact_us: "Kontaktieren Sie uns", our_menu: "Unsere Speisekarte",
    persons: "Personen", select_room: "Auswählen",
    menu_title: "Speisekarte des Restaurants", menu_kicker: "Hotel Restaurant Varbitsa", menu_updating: "Die Speisekarte wird aktualisiert.",
  },
  fr: {
    nav_home: "Accueil", nav_hotel: "Hôtel", nav_rooms: "Chambres", nav_restaurant: "Restaurant",
    nav_menu: "Menu", nav_gallery: "Galerie", nav_book: "Réserver", nav_contact: "Contact",
    hero_title: "Hôtel Restaurant Varbitsa",
    hero_sub: "La sérénité au cœur de la nature, une hospitalité chaleureuse et une cuisine authentique à Varbitsa.",
    btn_book_room: "Réserver une chambre", btn_restaurant: "Restaurant",
    staff_login: "Connexion personnel",
    sec_hotel: "L'Hôtel", sec_rooms: "Nos Chambres", sec_apartments: "Appartements",
    sec_restaurant: "Le Restaurant", sec_nature: "Nature / Varbitsa", sec_gallery: "Galerie",
    sec_booking: "Réservation", sec_contact: "Contact",
    hotel_desc: "10 hébergements confortables entourés de verdure — 8 chambres standard et 2 appartements spacieux avec grande terrasse.",
    restaurant_desc: "Une cuisine bulgare authentique préparée avec amour et des produits locaux frais.",
    nature_desc: "Varbitsa est entourée de forêts et d'une nature préservée — l'endroit idéal pour se détendre.",
    view_menu: "Voir le menu", book_now: "Réserver",
    check_availability: "Vérifier la disponibilité", arrival: "Arrivée", departure: "Départ",
    adults: "Adultes", children: "Enfants", babies: "Bébés (0–2)", nights: "nuits",
    per_night: "par nuit", total_stay: "séjour total", capacity: "Capacité", view_label: "Vue",
    amenities: "Équipements", no_rooms: "Aucune chambre disponible pour la période choisie.",
    guest_details: "Coordonnées du client", first_name: "Prénom", last_name: "Nom", phone: "Téléphone",
    email: "Email (optionnel)", country: "Pays", special: "Demande spéciale",
    confirm_booking: "Confirmer la réservation", booking_success: "Réservation confirmée !",
    opening_hours: "Heures d'ouverture", contact_us: "Contactez-nous", our_menu: "Notre menu",
    persons: "personnes", select_room: "Choisir",
    menu_title: "Carte du restaurant", menu_kicker: "Hôtel Restaurant Varbitsa", menu_updating: "La carte est en cours de mise à jour.",
  },
};

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem("vb_lang") || "bg");
  const change = useCallback((l) => { setLang(l); localStorage.setItem("vb_lang", l); }, []);
  const t = useCallback((k) => (T[lang] && T[lang][k]) || T.bg[k] || k, [lang]);
  const value = useMemo(() => ({ lang, setLang: change, t }), [lang, change, t]);
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
export const tr = (lang, k) => (T[lang] && T[lang][k]) || T.bg[k] || k;
// Localised field: obj.name_en / obj.description_fr … falling back to Bulgarian.
export const loc = (obj, field, lang) => {
  if (!obj) return "";
  if (lang !== "bg" && obj[`${field}_${lang}`]) return obj[`${field}_${lang}`];
  return field === "name" ? (obj.name_bg || obj.name) : obj[field] || "";
};
export const LANGS = [
  { code: "bg", label: "БГ" }, { code: "en", label: "EN" },
  { code: "de", label: "DE" }, { code: "fr", label: "FR" },
];
